<template lang="html">
	<div v-if="article" class="article" @click="goTo">
		<div class="head-article row">
			<div class="ctn-profile-picture">
				<img v-img-detect :src="article.author.image" alt="">
			</div>
			<div class="column ctn-infos">
				<div class="name">
					{{ article.author.name}}
				</div>
				<div class="date">
					<span class="icon-clock"></span> {{ article.created_at | moment('dddd DD MMMM YYYY')}}
				</div>
			</div>
		</div>
		<div class="body-article" :class="{column: article.type === 'big', row: article.type === 'small'}">
			<div class="ctn-img" :class="{ 'big': article.image }">
				<img :src="article.image" alt="">
			</div>
			<div class="ctn-text column">
				<div class="title" v-html="article.title">
				</div>
				<div class="ctn-tags row">
					<div class="tag" v-for="(tag, keyt) in article.news_tags" v-bind:key="keyt">
						{{ resolveTag(tag) }}
					</div>
				</div>
				<div class="desc" v-html="strip(article.body)"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'custom-article-small',
	props: ['article'],
	methods: {
		strip (s) { return s.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 120) + '...' },
		resolveTag (tag) {
			if (typeof tag === 'number') {
				const gTag = this.tags.filter((t) => (t.wordpress_tag_id === tag))[0]
				if (gTag) {
					return gTag.wordpress_tag_name
				} else {
					return null
				}
			} else {
				return tag.tags.wordpress_tag_name
			}
		},
		goTo () {
			if (this.article.link) {
				window.open(this.article.link)
			} else {
				this.$router.push({ name: 'Article', params: { id: this.article.id } })
			}
		}
	},
	computed: {
		...mapGetters({
			tags: 'tags'
		})
	}
}
</script>

<style lang="scss" scoped>
.article {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/common/components/article-small.vue